function addZero(n) {
    if (n > 9) return n
    return "0" + n
}

export function getTimestamp() {
    let timestamp = new Date();
    let time_string = timestamp.getFullYear() + "-" + addZero(timestamp.getMonth() + 1) + "-" + addZero(timestamp.getDate()) + " " + addZero(timestamp.getHours()) + ":" + addZero(timestamp.getMinutes()) + ":" + addZero(timestamp.getSeconds())

    return time_string;
}

export function formatTimestamp(ts) {
    let timestamp = new Date(ts);
    let time_string = timestamp.getFullYear() + "-" + addZero(timestamp.getMonth() + 1) + "-" + addZero(timestamp.getDate()) + " " + addZero(timestamp.getHours()) + ":" + addZero(timestamp.getMinutes()) + ":" + addZero(timestamp.getSeconds())

    return time_string;
}